import { Button, Col, DatePicker, Input, Row, Select, Space } from "antd";
import dayjs from 'dayjs';
import { FC } from "react";
import { useSelector } from "react-redux";
import { AddSvg, SearchSvg } from "utils/svgs";
import { checkPermission } from "utils/utils";
import styles from "./index.module.scss";
import { SearchAndFilterProps } from "./types";
const { RangePicker } = DatePicker;

const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
  const {
    performSearchHandler,
    searchValue,
    title,
    setSearch,
    selectedDate,
    setSelectedDate,
    totalRecords,
    statusFilter,
    onStatusFilterChange,
    categoryFilter,
    onCategoryFilterChange,
    categories = [],
    showAddButton = true,
    searchField = 'medicineName',
    onSearchFieldChange,
  } = props;

  const userPermissions = useSelector(
    (state: any) => state?.userProfile?.data
  );
  const isAddPermission =
    checkPermission(userPermissions?.permissions, {
      permissionName: 'Medicines',
      permission: ['add'],
    }) ||
    checkPermission(userPermissions?.permissions, {
      permissionName: 'DraftMedicinesRequest',
      permission: ['add', 'all'],
    });

  const showCategoryFilter = userPermissions?.isAdmin === true;
  const isAdmin = userPermissions?.isAdmin === true;
  const statusOptions = [
    { label: 'Pending', value: 'PENDING' },
    { label: 'Rejected', value: 'REJECTED' },
    { label: 'Approved', value: 'APPROVED' },
    { label: 'Mapped', value: 'MAPPED' },
    ...(showCategoryFilter ? [{ label: 'Deleted', value: 'DELETED' }] : []),
  ];

  const searchFieldOptions = [
    { label: 'Medicine Name', value: 'medicineName' },
    { label: 'Pharmacy Code', value: 'pharmacyCode' },
    ...(isAdmin ? [{ label: 'Pharmacy Name', value: 'pharmacyName' }] : []),
  ];

  const searchPlaceholder =
    searchField === 'pharmacyName'
      ? 'Search by Pharmacy Name'
      : searchField === 'pharmacyCode'
        ? 'Search by Pharmacy Code'
        : 'Search by Medicine Name';

  return (
    <div className={styles["search-filter"]}>
      <div className={styles["search-filter__wrapper"]}>
        <Row justify={"space-between"}>
          <Col>
            <div className={styles["search-filter__wrapper--title"]}>
              {title}
              <span className={styles["search-filter__wrapper--title--count"]}>({totalRecords})</span>
            </div>
          </Col>
          <Col>
            <Space>
              <Button
                onClick={() => {
                  setSearch('');
                  if (onStatusFilterChange) {
                    onStatusFilterChange('PENDING');
                  }
                  if (onSearchFieldChange) {
                    onSearchFieldChange('medicineName');
                  }
                  if (showCategoryFilter) {
                    onCategoryFilterChange?.(null);
                  }
                  setSelectedDate(null);
                }}
              >
                Clear all
              </Button>

              <Select
                value={searchField}
                size="large"
                style={{ width: 170 }}
                onChange={(value) => onSearchFieldChange?.(value)}
                options={searchFieldOptions}
              />

              <Input
                className={styles["search-filter__search"]}
                placeholder={searchPlaceholder}
                prefix={<SearchSvg />}
                onChange={performSearchHandler}
                value={searchValue}
                size="large"
                allowClear
              />

              <Select
                value={statusFilter ?? undefined}
                placeholder="Status"
                size="large"
                style={{ width: 140 }}
                onChange={(value) => onStatusFilterChange?.(value ?? null)}
                allowClear
                options={statusOptions}
              />
              {showCategoryFilter && (
                <>
                  <Select
                    showSearch
                    optionFilterProp="label"                
                    filterOption={(input, option) =>
                      (option?.label ?? '')
                        .toString()
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    value={categoryFilter ?? undefined}
                    placeholder="Category"
                    size="large"
                    style={{ width: 200 }}
                    onChange={(value) => onCategoryFilterChange?.(value ?? null)}
                    allowClear
                    options={categories.map((cat) => ({
                      label: cat.categoryName,
                      value: cat.id,
                    }))}
                  />
                </>
              )}

              <RangePicker
                picker="date"
                format="DD/MM/YYYY"
                style={{ width: 120, height: 40 }}
                allowClear
                onChange={(value) => {
                  if (!value || !value[0] || !value[1]) {
                    setSelectedDate(null);
                  } else {
                    setSelectedDate([
                      dayjs(value[0]).startOf("day"),
                      dayjs(value[1]).endOf("day")
                    ]);
                  }
                }}
                value={selectedDate}
              />

              {showAddButton && isAddPermission && (
                <div className={styles['user-table__action']}>
                  <button
                    type="button"
                    className={`btn-blue ${styles['user-table__action--button']}`}
                  >
                    <AddSvg />
                    <p>Add Medicines</p>
                  </button>
                </div>
              )}
            </Space>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SearchAndFilter;
